import CircleFraction from "./CircleFraction";
import Rectangle from "./Rectangle";
import Length from "./Length";

export default class HalfCircle extends CircleFraction {
	static NAME = "half-circle";

	get_name() {
		return HalfCircle.NAME;
	}

	get_fraction() {
		return 0.5;
	}

	get_enclosing_rectangle() {
		return new Rectangle( new Length( this.diameter.in_mm() ), new Length( this.diameter.in_mm() / 2 ) );
	}

	get_maximum_dimensions( maximum_rectangle ) {
		const shortest_side = maximum_rectangle.get_shortest_side();
		return {
			diameter: shortest_side
		};
	}
}
